// Lightweight in-app perf scratch space. The React <Profiler> at App.js wraps
// AppLayout and forwards every commit through `recordCommit` below; you can
// also call `markPhase` from any code path you want timestamped. Everything
// lands on `window.__steadilyPerf` so you can read it from `chrome://inspect`
// without rebuilding the app.

const RING_SIZE = 256;

const ring = new Array(RING_SIZE);
let writeIdx = 0;
let totalCommits = 0;
let slowCommits = 0;

const push = (entry) => {
  ring[writeIdx] = entry;
  writeIdx = (writeIdx + 1) % RING_SIZE;
};

export const recordCommit = (id, phase, actualDuration) => {
  totalCommits += 1;
  const slow = actualDuration > 16;
  if (slow) slowCommits += 1;
  push({ t: 'commit', ts: Date.now(), id, phase, ms: +actualDuration.toFixed(2), slow });
};

export const markPhase = (label, meta) => {
  push({ t: 'mark', ts: Date.now(), label, meta });
};

const snapshot = () => {
  const entries = [];
  for (let i = 0; i < RING_SIZE; i++) {
    const idx = (writeIdx + i) % RING_SIZE;
    const e = ring[idx];
    if (e) entries.push(e);
  }
  return {
    totalCommits,
    slowCommits,
    slowRatio: totalCommits === 0 ? 0 : +(slowCommits / totalCommits).toFixed(3),
    entries,
  };
};

const reset = () => {
  for (let i = 0; i < RING_SIZE; i++) ring[i] = undefined;
  writeIdx = 0;
  totalCommits = 0;
  slowCommits = 0;
};

if (typeof window !== 'undefined') {
  window.__steadilyPerf = {
    snapshot,
    reset,
    markPhase,
  };
}
